import { Component } from 'react'
import PropTypes from 'prop-types'

import { StyledSubHeading } from 'components/headings'

import { FORM_KEY_NEW } from 'shared/constants'
import InsertCardOrders from 'registry/components/insert-card-orders'

import AdminInsertCardOrderForm from '../admin-insert-card-order-form'

class InsertCardsSection extends Component {
  static propTypes = {
    isAdmin: PropTypes.bool,
  }

  render() {
    const { isAdmin, insertCardOrders } = this.props

    return (
      <>
        <StyledSubHeading>Free Registry Insert Cards</StyledSubHeading>
        <InsertCardOrders />
        {isAdmin && insertCardOrders.length ? (
          <>
            <hr className="mbl" />
            <AdminInsertCardOrderForm formKey={FORM_KEY_NEW} />
          </>
        ) : null}
      </>
    )
  }
}

export default InsertCardsSection
